export enum AppRouteIdentifier {
	MasterIngredientList,
	UpdateMasterIngredient,
	ChangedMasterIngredient,
	SubmitMasterIngredient,
	ProductAnalyze,
}
